export default __webpack_public_path__ + "static/media/arrowScalableIcon.7035d84c.svg";